import React from 'react';
export function DetailPageShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-15351" data-mp="1vp4nsbz7gwdz">
      <span className="sr-only" data-id="element-15352" data-mp="jpvxrvux0lut">Loading details…</span>
      {/* Back button and actions */}
      <div className="flex items-center justify-between" data-id="element-15353" data-mp="foan8h5usjns">
        <div className="h-5 w-32 bg-gray-200 rounded" data-id="element-15354" data-mp="fpvi67w2y4m6" />
        <div className="h-10 w-28 bg-gray-200 rounded-md" data-id="element-15355" data-mp="1ceb84533qfzt" />
      </div>
      {/* Main info card */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-15356" data-mp="17fqa8cbbo8ej">
        <div className="flex items-start gap-4 mb-6" data-id="element-15357" data-mp="17dnj1oyfo988">
          <div className="w-16 h-16 bg-gray-200 rounded-full" data-id="element-15358" data-mp="13ctxh28gr6ii" />
          <div className="flex-1" data-id="element-15359" data-mp="yf2403s67cc7">
            <div className="h-8 w-64 bg-gray-200 rounded mb-3" data-id="element-15360" data-mp="ydqsfhshh0aj" />
            <div className="space-y-2" data-id="element-15361" data-mp="3o3uejamyrs07">
              <div className="h-4 w-48 bg-gray-200 rounded" data-id="element-15362" data-mp="3o4vo1aoc06ft" />
              <div className="h-4 w-40 bg-gray-200 rounded" data-id="element-15363" data-mp="3j4hqwno9qgwk" />
              <div className="h-4 w-56 bg-gray-200 rounded" data-id="element-15364" data-mp="3j73xajzfaqd7" />
            </div>
          </div>
          <div className="h-6 w-20 bg-gray-200 rounded-full" data-id="element-15365" data-mp="3rjlh8n2pxfod" />
        </div>
        {/* Stats */}
        <div className="pt-6 border-t border-gray-200 grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-15366" data-mp="bpmt4n4r20r">
          {[1, 2, 3].map(i => <div key={i} data-id="element-15367" data-mp="3nh6y01v50dwk">
              <div className="h-3 w-24 bg-gray-200 rounded mb-2" data-id="element-15368" data-mp="3ngfalebp1mhd" />
              <div className="h-8 w-32 bg-gray-200 rounded" data-id="element-15369" data-mp="38sarwacn5ayl" />
            </div>)}
        </div>
      </div>
      {/* Tabs */}
      <div className="bg-white rounded-lg border border-gray-200" data-id="element-15370" data-mp="3dk2iulzplip9">
        <div className="border-b border-gray-200 flex gap-8 px-6" data-id="element-15371" data-mp="2zrm8f04haieb">
          {[1, 2, 3].map(i => <div key={i} className="py-4" data-id="element-15372" data-mp="33sy2piyarrsu">
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-15373" data-mp="33u0r9k85di5l" />
            </div>)}
        </div>
        {/* Tab content */}
        <div className="p-6 space-y-4" data-id="element-15374" data-mp="2pvsqf17zpwp5">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="border border-gray-200 rounded-lg p-4" data-id="element-15375" data-mp="2urrhwxom7uts">
              <div className="flex justify-between items-center" data-id="element-15376" data-mp="10d486g2vg71k">
                <div className="flex-1 space-y-2" data-id="element-15377" data-mp="vl2q2dj0vm3m">
                  <div className="h-4 w-48 bg-gray-200 rounded" data-id="element-15378" data-mp="vkb65zysfct6" />
                  <div className="h-3 w-32 bg-gray-200 rounded" data-id="element-15379" data-mp="rl2csw7ntgy5" />
                </div>
                <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-15380" data-mp="mlpdvd3ikjf7" />
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}